var map = {
	"./customer/routes.js": "12fd",
	"./material/routes.js": "cf10",
	"./product/routes.js": "b148",
	"./project/routes.js": "ea55",
	"./quotation/routes.js": "9d76",
	"./rating/routes.js": "c27f",
	"./report/routes.js": "dd40",
	"./service/routes.js": "e1de",
	"./settings/routes.js": "de76",
	"./ticket/routes.js": "d473",
	"./user/routes.js": "2e02"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "74855";